/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import { EquipmentCapabilitiesFragmentDoc } from './EquipmentCapabilitiesFragment'
import { FreightCapabilitiesFragmentDoc } from './FreightCapabilitiesFragment'
export type IFleetInfoFragment = { __typename?: 'MotorCarrier' } & Pick<
  Types.IMotorCarrier,
  'id' | 'endorsements'
> & {
    equipmentCapability?: Types.Maybe<
      { __typename?: 'MotorCarrierEquipmentCapability' } & Pick<
        Types.IMotorCarrierEquipmentCapability,
        | 'id'
        | 'isDryVanCapable'
        | 'isFlatbedCapable'
        | 'isReeferCapable'
        | 'powerUnitCount'
        | 'trailerCount'
      >
    >
    freightCapability?: Types.Maybe<
      { __typename?: 'MotorCarrierFreightCapability' } & Pick<
        Types.IMotorCarrierFreightCapability,
        'id' | 'isDrayageCapable' | 'isFtlCapable' | 'isIntermodalCapable' | 'isLtlCapable'
      >
    >
  }

export const FleetInfoFragmentDoc = gql`
  fragment FleetInfo on MotorCarrier {
    id
    endorsements
    equipmentCapability {
      ...EquipmentCapabilities
    }
    freightCapability {
      ...FreightCapabilities
    }
  }
  ${EquipmentCapabilitiesFragmentDoc}
  ${FreightCapabilitiesFragmentDoc}
`
